import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {BIconHourglass, BIconSearch} from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.component("BIconHourglass", BIconHourglass)
Vue.component("BIconSearch", BIconSearch)